import React, { useEffect, useRef, useState } from 'react'
import { useHistory, Redirect } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import '../CreateProduct.css'
import {
  makeStyles,
  Paper,
  Button,
  CircularProgress,
} from '@material-ui/core'
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { useForm } from 'react-hook-form'
import clsx from 'clsx'
import classNames from 'classnames'
import mapValues from 'lodash/mapValues'
import CustomAlert from '../../CustomAlert'
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars'
import CheckUserProvider from '../../../AllHooks/CheckUserProvider'
import { parseDate, sleep } from '../../Models/CommonFunc'
import { Helmet } from 'react-helmet'
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { createSupplyBillsDocument, getSupplyBillsDocumentCount } from '../../../Backend/firebase/supply-bills'
import db from '../../../Backend/firebase/firebase'
import { getAllChemistUsersDocument, getAllSupplyOrderDocument } from '../../../Backend/firebase/supply-order'
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import autoTable from "jspdf-autotable";
import { extractNumber } from '../../../mock'
const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

const useStyles = makeStyles((theme) => ({
  root: {},
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'initial',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: '100%',
    padding: '20px',
  },
}))

function GenerateOrderInvoice() {
  const { register, handleSubmit, errors, reset, setValue } = useForm()
  const classes = useStyles()
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight)
  const [openNotify, setOpenNotify] = React.useState(false)
  const [notificationMessage, setNotificationMessage] = useState('')
  const [alertType, setAlertType] = useState('')
  const [InvoiceDate, setInvoiceDate] = useState(parseDate(new Date()))
  const [previewState, setPreviewState] = useState({})
  const [isPreview, setIsPreview] = useState(false)
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(false)
  const [isChemistManully, setIsChemistManully] = useState(false)
  const { userData } = CheckUserProvider()
  const [records, setRecords] = useState([]);
  const [chemistEntry, setChemistEntry] = useState([])
  const [chemistItems, setChemistItems] = useState([])
  const tableRef = useRef();
  const DEFAULT_DISCOUNT = 6;
  const DEFAULT_TAX = 12;

  const [InvoiceNoCount, setInvoiceNoCount] = useState('');
  const [InvoiceNo, setInvoiceNo] = useState('');
  const [BillType, setBillType] = useState('Select Option');
  var batch = db.batch()
  const [selectedItems, setSelectedItems] = useState([]);

  const ITEM_HEIGHT = 48
  const ITEM_PADDING_TOP = 8
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  }

  useEffect(async () => {
    try {
      const getSupplyBillsCount = await getSupplyBillsDocumentCount();
      setInvoiceNoCount(getSupplyBillsCount);
    } catch (error) {
      console.log("Error Occur in Get Sales Bills", error)
    }
  }, []);

  useEffect(async () => {
    if (userData) {
      try {
        const getChemistDetails = await getAllChemistUsersDocument()
        setChemistItems(getChemistDetails)
      } catch (error) {
        console.log('Error Occur in Get Products And Sales', error)
      }
    }
  }, [userData])

  const onSubmit = async (data) => {
    console.log('on Tap Submit')
  }

  const generateString = () => {
    let result = ' ';
    const charactersLength = characters.length;
    for (let i = 0; i < 4; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result.toUpperCase();
  }

  const handlePreviewSubmit = () => {
    if (selectedItems?.length > 0) {
      setSelectedItems(selectedItems);

      handleSubmit(async (data) => {
        const newSupplyBills = {
          userId: userData.uid,
          BillType: data.BillType,
          storeName: data.storeName,
          storeAddress: data.storeAddress,
          phoneNumber: data.phoneNumber,
          email: data.email,
          gstNo: data.gstNo,
          drugLicense: data.drugLicense,
          InvoiceNo: data.InvoiceNo,
          InvoiceDate: InvoiceDate,
          ProductEntry: selectedItems,
          chemistEntry,
        };
        setPreviewState(newSupplyBills);
        setIsPreview(true);
      })();
    } else {
      setNotificationMessage('Please Select Product for generate Invoice!!')
      setOpenNotify(true)
      setAlertType('error')
      setIsLoading(false)
    }
  };

  const handleSaveSubmit = () => {
    if (previewState?.ProductEntry?.length > 0) {
      const isConfirmed = window.confirm("Are you sure you want to generate invoice?");
      if (isConfirmed) {
        handleSubmit(async (data) => {
          setIsLoading(true)

          var newSupplyBills = {}
          newSupplyBills.userId = userData.uid;
          newSupplyBills.BillType = previewState.BillType;
          newSupplyBills.storeName = previewState?.storeName ? previewState.storeName : null;
          newSupplyBills.storeAddress = previewState?.storeAddress ? previewState.storeAddress : null;
          newSupplyBills.phoneNumber = previewState?.phoneNumber ? previewState.phoneNumber : null;
          newSupplyBills.email = previewState?.email ? previewState.email : null;
          newSupplyBills.gstNo = previewState?.gstNo ? previewState.gstNo : null;
          newSupplyBills.drugLicense = previewState?.drugLicense ? previewState.drugLicense : null;
          newSupplyBills.InvoiceNo = previewState.InvoiceNo;
          newSupplyBills.InvoiceDate = InvoiceDate;
          newSupplyBills.ProductEntry = previewState.ProductEntry;
          newSupplyBills.chemistEntry = chemistEntry;
          newSupplyBills.GSTValue = finalCalculation()?.TotalGST;
          newSupplyBills.GrossValue = finalCalculation()?.TotalGrossAmount;
          newSupplyBills.DiscountAmount = finalCalculation()?.TotalDiscount;
          newSupplyBills.TotalAmount = finalCalculation()?.NetAmount;
          try {
            var salesBills = createSupplyBillsDocument(newSupplyBills)
            if (salesBills) {
              setNotificationMessage('Invoice Generated Successfully!')
              setOpenNotify(true)
              setAlertType('success')
              reset()
              setIsLoading(false)
              setTimeout(routeToPages, 500)
            } else {
              setNotificationMessage(
                'Something went wrong, Please try again later!!',
              )
              setOpenNotify(true)
              setAlertType('error')
              setIsLoading(false)
              history.push('/supply/generate-invoice')
            }
          } catch (error) {
            console.error(error)
            setNotificationMessage('Something went wrong, Please try again later!!')
            setOpenNotify(true)
            setAlertType('error')
            setIsLoading(false)
            history.push('/supply/generate-invoice')
          }
        })()
      } else {
        console.log("Form submission canceled.");
      }
    } else {
      setNotificationMessage('Please Select Product for generate Invoice!!')
      setOpenNotify(true)
      setAlertType('error')
      setIsLoading(false)
    }
  }

  const editPreview = () => {
    setIsPreview(false)
    setTimeout(() => {
      mapValues(previewState, (value, key) => setValue(key, value))
    })
  }

  const convertToSlug = (input) => input?.toLowerCase()?.replace(/[^a-z0-9\s]/g, '')?.replace(/\s+/g, '_');
  const downloadInvoice = (callback) => {
    const tableElement = tableRef.current;
    if (!tableElement) return;

    html2canvas(tableElement).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const imgWidth = 190; // Full width for A4
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);

      // Save the PDF
      const fileName = previewState?.chemistEntry?.storeName
        ? `${convertToSlug(previewState?.chemistEntry?.storeName)}.pdf`
        : "invoice.pdf";
      pdf.save(fileName);

      if (callback) callback();
    });
  };

  const printInvoice = (callback) => {
    const printContents = tableRef.current.innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;

    // Ensure navigation happens after print dialog closes
    setTimeout(() => {
      if (callback) callback();
    }, 100);
  };

  const routeToPages = () => {
    downloadInvoice(() => {
      history.push('/supply/invoice-history');
    });
  }

  const handleInvoiceDateChange = (e) => {
    setInvoiceDate(parseDate(e.target.value))
  }

  const handleOnSearch = (string, results) => {
    console.log('handleOnSearch', string, results)
  }

  const handleOnHover = (result) => {
    console.log('handleOnHover', result)
  }

  const handleOnSelectChemist = (item) => {
    setChemistEntry(item)
    setTimeout(() => {
      mapValues(item, (value, key) => setValue(key, value))
    })
  }

  const handleOnFocus = () => {
    console.log('Focused')
  }

  const formatResultChemist = (item) => {
    return (
      <>
        <span style={{ display: 'block', textAlign: 'left' }}>
          {item.storeName} {item.storeAddress}
        </span>
      </>
    )
  }

  const finalCalculation = () => {
  
    // Initialize accumulators for totals
    let totalGrossAmount = 0;
    let totalDiscount = 0;
    let totalGst = 0;
    let netAmount = 0;
  
    // Iterate over the array and perform calculations
    if(previewState && previewState?.ProductEntry && previewState?.ProductEntry?.length > 0) {

      previewState?.ProductEntry.forEach((product) => {
        const { Rate, ProductQuantity, DiscountAmount, Tax } = product;
    
        // Parse values to ensure proper calculations
        const tax = parseFloat(Tax);
        const rate = parseFloat(Rate);
        const quantity = parseFloat(extractNumber(ProductQuantity));
        const discount = parseFloat(DiscountAmount);
    
        // Step 1: Calculate Gross Amount
        const grossAmount = rate * quantity;

        // Step 1: Calculate Gross Amount
        const indiviualDiscount = (rate * quantity) * discount/100;
    
        // Step 2: Calculate GST Amount
        const gstAmount = (grossAmount - indiviualDiscount)* tax/ 100;
    
        // Step 5: Calculate Net Amount for Product
        const netAmountForProduct = BillType === "GST Bill" ? (grossAmount + gstAmount - indiviualDiscount) : (grossAmount - indiviualDiscount);
    
        // Aggregate totals
        totalGrossAmount += grossAmount;
        totalDiscount += indiviualDiscount;
        totalGst += gstAmount;
        netAmount += netAmountForProduct;
      });
  
      // Return final result in a single object
      return {
        TotalGrossAmount: totalGrossAmount.toFixed(2),
        TotalDiscount: totalDiscount.toFixed(2),
        TotalGST: totalGst.toFixed(2),
        NetAmount: netAmount.toFixed(2),
      };
    }
  };

  useEffect(async () => {
    if (userData) {
      setIsLoading(true);
      try {
        const getSupplyOrder = await getAllSupplyOrderDocument();
        setRecords(getSupplyOrder);
        setIsLoading(false);
      } catch (error) {
        console.log("Error Occur in Get Order", error)
        setIsLoading(false);
      }
    }
  }, [userData]);

  const onTapNextButton = async () => {
    setIsLoading(true);
    const filterRecord = records?.filter(x => x?.ChemistInfo?.trim()?.toLowerCase()?.includes(chemistEntry?.storeName.trim()?.toLowerCase()))?.filter(x => parseDate(x.SupplyOrderPostedDateTime).includes(InvoiceDate));
    const updatedFilterRecord = filterRecord.map((item) => ({
      ...item,
      DiscountAmount: DEFAULT_DISCOUNT,
      Tax: DEFAULT_TAX,
    }));
    setSelectedItems(updatedFilterRecord);
    setIsLoading(false);
  }

  // Delete item from selectedItems
  const handleDeleteItem = (_id) => {
    setSelectedItems(selectedItems.filter(item => item._id !== _id));
  };

  return (
    <>
      <div className="createProduct mt-2">
        <Helmet>
          <meta name="description" content="Generate Invoice" />
          <title>Generate Invoice | Kaipsool Pharmatech</title>
        </Helmet>
        <Paper className={fixedHeightPaper}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              {!isPreview && (
                <>
                  <h5 className="mt-3">
                    Chemist Details: &nbsp;
                    {isChemistManully ? (
                      <VisibilityOffIcon
                        onClick={() => {
                          setIsChemistManully(false)
                          setTimeout(() => {
                            mapValues(chemistEntry, (value, key) =>
                              setValue(key, value),
                            )
                          })
                        }}
                      />
                    ) : (
                      <VisibilityIcon
                        onClick={() => {
                          setIsChemistManully(true)
                          setTimeout(() => {
                            mapValues(chemistEntry, (value, key) =>
                              setValue(key, value),
                            )
                          })
                        }}
                      />
                    )}
                  </h5>
                  <div className="row mb-3">
                    <div className="col-md-7 mb-2">
                      <ReactSearchAutocomplete
                        items={chemistItems}
                        placeholder="Search Chemist..."
                        fuseOptions={{ keys: ['storeName'] }}
                        // necessary, otherwise the results will be blank
                        resultStringKeyName="storeName"
                        onSearch={handleOnSearch}
                        onHover={handleOnHover}
                        onSelect={handleOnSelectChemist}
                        onFocus={handleOnFocus}
                        autoFocus
                        formatResult={formatResultChemist}
                        styling={{
                          borderRadius: '8px',
                          zIndex: 1000,
                        }}
                      />
                    </div>
                    <div className="col-md-3 mb-2">
                      <span className="form-control registerEmp__textbox registerEmp__datePicker">
                        <DatePickerComponent
                          id="InvoiceDate"
                          name="InvoiceDate"
                          value={InvoiceDate}
                          cssclassName="e-outline"
                          onChange={(e) => handleInvoiceDateChange(e)}
                          ref={register()}
                          format="dd/MM/yyyy"
                          cleared={() => setInvoiceDate('')}
                        />
                      </span>
                    </div>
                    <div className="col-md-1 mb-2 mt-1">
                      <div className="addBox">
                        <Button
                          onClick={onTapNextButton}
                          variant="contained"
                          className="registerEmp__btnLogin jsmAdd"
                        >
                          {'Next'}
                        </Button>
                      </div>
                    </div>
                    <div className="col-md-1 mb-2 mt-1">
                      <div className="addBox">
                        <Button
                          onClick={() => setSelectedItems([])}
                          variant="contained"
                          className="registerEmp__btnLogin jsmAdd btn-secondary-color"
                        >
                          {'Clear'}
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className={isChemistManully ? "row PartyManully" : "row InactivePartyManully"}>
                    <div className="col-md-5 mb-2">
                      Store Name
                      <input
                        type="text"
                        className={classNames(
                          'form-control registerEmp__textbox',
                        )}
                        name="storeName"
                        autoComplete="none"
                        ref={register()}
                      />
                    </div>
                    <div className="col-md-7 mb-2">
                      Store Address
                      <input
                        type="text"
                        className={classNames(
                          'form-control registerEmp__textbox',
                        )}
                        name="storeAddress"
                        autoComplete="none"
                        ref={register()}
                      />
                    </div>
                    <div className="col-md-3 mb-2">
                      Email Id
                      <input
                        type="text"
                        className={classNames(
                          'form-control registerEmp__textbox',
                        )}
                        name="email"
                        autoComplete="none"
                        ref={register()}
                      />
                    </div>
                    <div className="col-md-3 mb-2">
                      Contact No
                      <input
                        type="text"
                        className={classNames(
                          'form-control registerEmp__textbox',
                        )}
                        name="phoneNumber"
                        autoComplete="none"
                        ref={register()}
                      />
                    </div>
                    <div className="col-md-3 mb-2">
                      GST No
                      <input
                        type="text"
                        className={classNames(
                          'form-control registerEmp__textbox',
                        )}
                        name="gstNo"
                        autoComplete="none"
                        ref={register()}
                      />
                    </div>
                    <div className="col-md-3 mb-2">
                      D/L No
                      <input
                        type="text"
                        className={classNames(
                          'form-control registerEmp__textbox',
                        )}
                        name="drugLicense"
                        autoComplete="none"
                        ref={register()}
                      />
                    </div>
                  </div>
                  {(selectedItems && selectedItems.length > 0) ? (<>
                    <h5 className="mt-3">Others Information:</h5>
                    <div className="col-md-3 mb-2">
                      Bill Type
                      <select
                        className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.BillType })}
                        aria-label="Default select example"
                        name="BillType" ref={register({
                          required: 'Please select Bill Type!',
                          validate: {
                            defaultValue: value => value !== "Select Option" || 'Please select Bill Type!'
                          }
                        })}
                        onChange={(event) => {
                          setBillType(event.target.value)
                          if (event.target.value === "GST Bill") {
                            setInvoiceNo(`SUP1000${InvoiceNoCount}`)
                          } else if (event.target.value === "Challan Bill") {
                            setInvoiceNo(`CH1000${InvoiceNoCount}`)
                          }
                        }}
                        defaultValue="Select Bill Type" >
                        <option value="">Select Bill Type</option>
                        <option value="GST Bill">GST Bill</option>
                        <option value="Challan Bill">Challan Bill</option>
                      </select>
                    </div>
                    <div className="col-md-3 mb-2">
                      Invoice No
                      <input
                        type="text"
                        className={classNames(
                          'form-control registerEmp__textbox',
                        )}
                        name="InvoiceNo"
                        value={InvoiceNo}
                        autoComplete="none"
                        ref={register()}
                      />
                    </div>
                    <h5 className="mt-3">Product Details:</h5>
                    <table className="table">
                      <thead>
                        <tr>
                          <td>S.No</td>
                          <td>Particulars</td>
                          <td>Pack Size</td>
                          <td>Scheme</td>
                          <td>Quantity</td>
                          <td>Exp Date</td>
                          <td>HSN Code</td>
                          <td>Batch No</td>
                          <td>MRP</td>
                          {BillType === "GST Bill" && <td>Tax</td>}
                          <td>Discount</td>
                          <td>Rate</td>
                          {/* {BillType === "GST Bill" && <td>SGST</td>}
                          {BillType === "GST Bill" && <td>CGST</td>} */}
                          <td>Amount</td>
                          <td>Action</td>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedItems.map((item, index) => {
                          let TotalAmount = item?.Rate * extractNumber(item?.ProductQuantity);

                          const handleInputChange = (key, value) => {
                            const updatedItems = [...selectedItems];
                            updatedItems[index][key] = value;
                            setSelectedItems(updatedItems);
                          };


                          return (
                            <tr key={item._id}>
                              <td>{index + 1}</td>
                              <td>{item?.ProductName}</td>
                              <td>
                                <input
                                  className="smallInput"
                                  type="text"
                                  value={item?.PackagingSize}
                                  onChange={(e) => handleInputChange("PackagingSize", e.target.value)}
                                />
                              </td>
                              <td>
                                <input
                                  className="smallInput"
                                  type="text"
                                  value={item?.ProductScheme}
                                  onChange={(e) => handleInputChange("ProductScheme", e.target.value)}
                                />
                              </td>
                              <td>
                                <input
                                  className="smallInput"
                                  type="text"
                                  value={item?.ProductQuantity}
                                  onChange={(e) => handleInputChange("ProductQuantity", e.target.value)}
                                />
                              </td>
                              <td>
                                <input
                                  className="handleInput"
                                  type="text"
                                  value={item?.ExpiryDate}
                                  onChange={(e) => handleInputChange("ExpiryDate", e.target.value)}
                                />
                              </td>
                              <td>
                                <input
                                  className="handleInput"
                                  type="text"
                                  value={item?.HSNCode}
                                  onChange={(e) => handleInputChange("HSNCode", e.target.value)}
                                />
                              </td>
                              <td>
                                <input
                                  className="handleInput"
                                  type="text"
                                  value={item?.BatchNo}
                                  onChange={(e) => handleInputChange("BatchNo", e.target.value)}
                                />
                              </td>
                              <td>
                                <input
                                  className="smallInput"
                                  type="number"
                                  value={item?.ProductMRP}
                                  onChange={(e) => handleInputChange("ProductMRP", e.target.value)}
                                />
                              </td>
                              {BillType === "GST Bill" && <td>
                                <input
                                  className="smallInput"
                                  type="number"
                                  value={item?.Tax}
                                  onChange={(e) => handleInputChange("Tax", e.target.value)}
                                />
                              </td>}
                              <td>
                                <input
                                  className="smallInput"
                                  type="number"
                                  value={item?.DiscountAmount}
                                  onChange={(e) => handleInputChange("DiscountAmount", e.target.value)}
                                />
                              </td>
                              <td>
                                <input
                                  className="smallInput"
                                  type="number"
                                  value={item?.Rate}
                                  onChange={(e) => handleInputChange("Rate", e.target.value)}
                                />
                              </td>
                              {/* {BillType === "GST Bill" && <td>{`Rs. ${SGSTValue}`}</td>}
                              {BillType === "GST Bill" && <td>{`Rs. ${CGSTValue}`}</td>} */}
                              <td>{`Rs. ${TotalAmount?.toFixed(2)}`}</td>
                              <td className="deleteCursor">
                                <DeleteIcon onClick={() => handleDeleteItem(item._id)} />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </>) : <>
                    <h3 className='text-center mt-5 mb-5'>No Order Found for selected Chemist and Date!!</h3>
                  </>}
                </>
              )}
              {isPreview && (
                <div className="col-md-12">
                  <div className="backButton">
                    <div className="inline__block">
                      <Button
                        onClick={() => editPreview()}
                        color="error"
                        variant="outlined"
                        className="registerEmp__btnRemove"
                      >
                        <EditIcon />
                        &nbsp; {'Edit'}
                      </Button>
                    </div>
                  </div>

                  <div ref={tableRef}>
                    <table className="table mt-5">
                      <tr>
                        <td>
                          <h5 className="card-events-title product__mainTitle">
                            {userData.storeName}
                          </h5>
                          {
                            <p className="card-events-title">
                              <b>{userData.storeAddress}</b>
                            </p>
                          }
                          {
                            <p className="card-events-title">
                              Contact No: <b>{userData.phoneNumber}</b>
                            </p>
                          }
                          {
                            <p className="card-events-title">
                              Email Id: <b>{userData.email}</b>
                            </p>
                          }
                          {
                            <p className="card-events-title">
                              GST No: <b>{userData.gstNo}</b>
                            </p>
                          }
                          {
                            <p className="card-events-title">
                              DL No: <b>{userData.drugLicense}</b>
                            </p>
                          }
                        </td>
                        <td>
                          {previewState.InvoiceNo && (
                            <p className="card-events-title">
                              Invoice No: <b>{previewState.InvoiceNo}</b>
                            </p>
                          )}
                          {previewState.InvoiceDate && (
                            <p className="card-events-title">
                              Invoice Date: <b>{previewState.InvoiceDate}</b>
                            </p>
                          )}
                        </td>
                        <td>
                          {(previewState?.storeName || previewState?.chemistEntry?.storeName) && (
                            <p className="card-events-title">
                              Party Name: <b>{previewState.storeName || previewState.chemistEntry.storeName || previewState.chemistEntry.name}</b>
                            </p>
                          )}
                          {(previewState?.storeAddress || previewState?.chemistEntry?.storeAddress) && (
                            <p className="card-events-title">
                              Address: <b>{previewState.storeAddress || previewState.chemistEntry.storeAddress}</b>
                            </p>
                          )}
                          {(previewState?.email || previewState?.chemistEntry?.email) && (
                            <p className="card-events-title">
                              Email Id: <b>{previewState?.email || previewState.chemistEntry.email}</b>
                            </p>
                          )}
                          {(previewState?.gstNo || previewState?.chemistEntry?.gstNo) && (
                            <p className="card-events-title">
                              GST No: <b>{previewState.gstNo || previewState.chemistEntry.gstNo}</b>
                            </p>
                          )}
                          {(previewState?.drugLicense || previewState.chemistEntry.drugLicense) && (
                            <p className="card-events-title">
                              DL No: <b>{previewState?.drugLicense || previewState.chemistEntry.drugLicense}</b>
                            </p>
                          )}
                        </td>
                      </tr>
                    </table>
                    <table className="table">
                      <thead>
                        <td>S.No</td>
                        <td>Particulars</td>
                        <td>Pack Size</td>
                        <td>Scheme</td>
                        <td>Quantity</td>
                        <td>Exp Date</td>
                        <td>HSN Code</td>
                        <td>Batch No</td>
                        <td>MRP</td>
                        {BillType === "GST Bill" && <td>Tax</td>}
                        <td>Discount</td>
                        <td>Rate</td>
                        {/* {BillType === "GST Bill" && <td>SGST</td>}
                        {BillType === "GST Bill" && <td>CGST</td>} */}
                        <td>Amount</td>
                      </thead>
                      <tbody>
                        {previewState &&
                          previewState?.ProductEntry &&
                          previewState?.ProductEntry?.length > 0 &&
                          previewState.ProductEntry.map((item, index) => {
                            let TotalAmount = item?.Rate * extractNumber(item?.ProductQuantity);
                            return (
                              <tr>
                                <td>{index + 1}</td>
                                <td>{item?.ProductName}</td>
                                <td>{item?.PackagingSize}</td>
                                <td>{item?.ProductScheme}</td>
                                <td>{item?.ProductQuantity}</td>
                                <td>{item?.ExpiryDate ? item?.ExpiryDate : 'NA'}</td>
                                <td>{item?.HSNCode ? item?.HSNCode : "NA"}</td>
                                <td>{item?.BatchNo ? item?.BatchNo : "NA"}</td>
                                <td>
                                  {item?.ProductMRP
                                    ? `Rs. ${item?.ProductMRP}`
                                    : '0'}
                                </td>
                                {BillType === "GST Bill" && <td>{`${item?.Tax}`}</td>}
                                <td>{item?.DiscountAmount}</td>
                                <td>{item?.Rate}</td>
                                {/* {BillType === "GST Bill" && <td>{`Rs. ${SGSTValue}`}</td>}
                                {BillType === "GST Bill" && <td>{`Rs. ${CGSTValue}`} </td>} */}
                                <td>{`Rs. ${TotalAmount?.toFixed(2)}`}</td>
                              </tr>
                            )
                          })}
                        <tr>
                          <td colSpan={BillType === "GST Bill" ? 11 : 10}></td>
                          <td>Gross Amount</td>
                          <td>{`Rs. ${finalCalculation()?.TotalGrossAmount}`}</td>
                        </tr>
                        <tr>
                          <td colSpan={BillType === "GST Bill" ? 11 : 10}></td>
                          <td>Total Discount</td>
                          <td>{`Rs. ${finalCalculation()?.TotalDiscount}`}</td>
                        </tr>
                        {BillType === "GST Bill" && <tr>
                          <td colSpan={11}></td>
                          <td>Total GST</td>
                          <td>{`Rs. ${finalCalculation()?.TotalGST}`}</td>
                        </tr>}
                        {BillType === "GST Bill" && <tr>
                          <td colSpan={11}></td>
                          <td>CGST</td>
                          <td>{`Rs. ${(finalCalculation()?.TotalGST / 2).toFixed(2)}`}</td>
                        </tr>}
                        {BillType === "GST Bill" && <tr>
                          <td colSpan={11}></td>
                          <td>SGST</td>
                          <td>{`Rs. ${(finalCalculation()?.TotalGST / 2).toFixed(2)}`}</td>
                        </tr>}
                        <tr>
                          <td colSpan={BillType === "GST Bill" ? 11 : 10}>
                            Account Holder:	Butame Pharma Pvt Ltd	<br />
                            Account No:		10084890331	<br />
                            Account Type:		Current Acount <br />
                            Bank Name:		IDFC First Bank <br />
                            Bank IFSC Code:		IDFB0020132
                          </td>
                          <td><b>Net Total</b> </td>
                          <td>{`Rs. ${finalCalculation()?.NetAmount}`}</td>
                        </tr>
                        <tr></tr>
                        {BillType === "GST Bill" && <tr>
                          <td colSpan={13}>
                            Note: We do not entertain any credit based supply of the goods.<br />
                            Please return the damaged or expired products to the delivery boy at the same time.<br />
                            For queries, contact us at: hello@kaipsool.com
                          </td>
                        </tr>}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {(selectedItems && selectedItems.length > 0) && <div className="col-sm-12 text-right mt-2">
                <div className="d-flex justify-content-center">
                  {!isPreview && (
                    <div className="p-2">
                      <Button
                        type="submit"
                        name="preview"
                        value="preview"
                        variant="contained"
                        onClick={handlePreviewSubmit}
                        className="registerEmp__btnLogin preview"
                      >
                        {'Preview'}
                      </Button>
                    </div>
                  )}
                  {isPreview && (
                    <div className="p-2">
                      <Button
                        type="submit"
                        name="saved"
                        value="saved"
                        variant="contained"
                        disabled={isLoading ? true : false}
                        onClick={handleSaveSubmit}
                        className="registerEmp__btnLogin save"
                      >
                        {isLoading ? <CircularProgress size={18} /> : 'Download Invoice'}
                      </Button>
                    </div>
                  )}
                </div>
              </div>}
            </div>
          </form>
        </Paper>
      </div>
      <CustomAlert
        setOpenNotify={setOpenNotify}
        openNotify={openNotify}
        messageType={alertType}
        notificationMessage={notificationMessage}
      />
    </>
  )
}

export default GenerateOrderInvoice